// 原 CSS Modules 的类名映射，去掉构建哈希以便阅读。
export default {
  lineName: "ScenarioLine__lineName",
  lineWere: "ScenarioLine__lineWere",
  lineYou: "ScenarioLine__lineYou",
  scenarioLine: "ScenarioLine__scenarioLine",
};
